/* eslint-disable strict */
/**
* @description base class with standard function - Feel free to extend the base class with additional functions
*/
(function (base, $, undefined) {
    /**
    * @description wrapper for typeof keyword
    * @param prop propostion which should be tested
    * @param supposed value of the proposition
    * @returns {boolean}
    */
    base.checkProperties = function (prop, value) {
        if (typeof prop === value) {
            return true;
        }
        return false;
    };

    /**
    * @description wrapper for log mechanism - iE8 does not support console object if debugger is closed
    * @param str string which should ne display in logger
    */
    base.log = function (str) {
        if (base.checkProperties(console, 'object')) {
            console.log(str);
        }
    };
    base.errorCodes = {
        notLoggedIn: {
            code: 409,
            tonality: {
                consumer: 'Bitte logge dich ein!',
                business: 'Bitten loggen Sie sich ein.'
            }
        },
        technicalError: {
            code: 500,
            tonality: {
                consumer: 'Es ist ein technischer Fehler aufgetreten, bitte versuche es später erneut',
                business: 'Es ist ein technischer Fehler aufgetreten, bitte versuchen Sie es später erneut'
            }
        }
    };


}(window.vf.bookservices = window.vf.bookservices || {}, jQuery));


(function (errorCodes, $, undefined) {
    errorCodes.socAlreadyBooked = {
        code: 512,
        tonality: {
            consumer: 'Die Tarifoption wurde bereits für deinen Tarif gebucht.',
            business: 'Die Tarifoption wurde bereits für Ihren Tarif gebucht.'
        }
    };
    errorCodes.notAllowed = {
        code: 511,
        tonality: {
            consumer: 'Die Tarifoption darf für deinen Tarif nicht gebucht werden.',
            business: 'Die Tarifoption dard für Ihren Tarif nicht gebucht werden.'
        }
    };
    errorCodes.notBookable = {
        code: 513,
        tonality: {
            consumer: 'Die Tarifoption ist derzeit nicht buchbar, bitte versuche es später erneut.',
            business: 'Die Tarifoption ist derzeit nicht buchbar, bitte versuchen Sie es später erneut.'
        }
    };
    errorCodes.socBooked = {
        code: 200,
        tonality: {
            consumer: 'Die Tarifoption [TO] wurde erfolgreich gebucht. Du erhälst in Kürze eine SMS.',
            business: 'Die Tarifoption [TO] wurde erfolgreich gebucht. Sie erhalten in Kürze eine SMS.'
        }
    };

}(window.vf.bookservices.errorCodes = window.vf.bookservices.errorCodes || {}, jQuery));

/**
* @description require base object
*/
(function (auth, $, undefined) {
    //Private Property
    var base = vf.bookservices;
    var config = {
        'urlCheckLogin': '/dr/cc/vf/userinfo/?_sd=fail',
        'urlLogout': '/dr/tmpl/logout',
        'urlLogin': '/dr/tmpl/login'
    };
    var successCodes = [
        201 //is sent when sms token is sent successfully - but unfurtanetly this code is also sent when the received token is entered wrongly
    ];
    var wrapLoginFunc = function (options) {
        $.ajax({
            url: config.urlLogin,
            dataType: 'json',
            type: 'POST',
            data: options.data,
            headers: {
                'x-vfssdublinversion': '4'
            },
            success: function (result) {
                code = result.code || result.errorCode;
                if (code) {
                    if (-1 === $.inArray(code, successCodes)) {
                        var t = result.message;
                        options.onLoginFailed({
                            code: result.code || result.errorCode,
                            message: t
                        });
                    } else {
                        options.onSuccess(result);
                    }
                } else if (true === result.error) {
                    options.onLoginFailed({
                        code: 500,
                        message: 'technical error'
                    });
                } else {
                    options.onSuccess(result);
                }
            },
            error: function (data) {
                options.onError(data);
            }
        });
    };

    /**
    * @description function generates an ajax call and checks if a customer is already logged in via 3G or an usual log in
    * @description url: https://eweb8.vfd2-testnet.de/dr/cc/vf/userinfo/ (https only)
    * @param data {object}
    * @param data.onLoggedIn {function} callback if customer is already logged
    * @param data.onNotLoggedIn {function} callback if customer is not logged in yet
    * @param data.onError {function} callback if the invoked service returns an error or is not available
    * since the function executes an asynchron call there is not delivered any return value - if an internal server error occurs please contact mondiamedia, in person Nils Sowen
    */
    auth.checkLoggedInStatus = function (data) {
        if (!base.checkProperties(data, 'object')) {
            base.log('missing data object as parameter in checkLoggedInStatus function');
        } else {
            $.ajax({
                url: data.url,
                type: 'POST',
                data: '',
                contentType: 'application/json',
                dataType: 'json',
                success: function (result) {
                    if (!auth.checkResultForLoginStatus(result)) {
                        if (base.checkProperties(data.onNotLoggedIn, 'function')) {
                            data.onNotLoggedIn(base.errorCodes.notLoggedIn);
                        } else {
                            base.log('no callback for "not logged in" functionality has been defined');
                        }
                    } else {
                        if (base.checkProperties(data.onLoggedIn, 'function')) {
                            //result depends on data-url
                            data.onLoggedIn({
                                code: 200,
                                result: result
                            });
                        } else {
                            base.log('no callback for "logged in" functionality has been defined');
                        }
                    }
                },
                error: function () {
                    if (base.checkProperties(data.onError, 'function')) {
                        data.onError();
                    } else {
                        base.log('no callback for "error" functionality has been defined');
                    }
                }
            });
        }
    };

    auth.getProperMSISDN = function (msisdn) {
        return msisdn.toString().replace(/(\d{2})(\d{3})(\d{7})/, '0$2 $3');
    };

    /**
    * @description function generates an ajax call try to login in a customer with username und password
    * @description url: https://eweb8.vfd2-testnet.de/dr/tmpl/login (https only)
    * @description private function
    * @param data {object}
    * @param data.options {object}
    * @param data.options.msisdn {string} msisdn of customer
    * @param data.options.go {string} url target after successful login - responsible for return object (examples: url = '/cc/vf/userinfo/?_sd=fail' returns only the msisdn of the customer, url = '/cc/vf/vfssdublin/index.xml' returns an complete JSON object with very much informations (could be oversized))
    * @param data.options.password {string} password internetkennwort - please don't use cpass if you use password for authentication
    * @param data.options.cpass {string} password kundenkennwort - please dont use password if you use cpass for authentication
    * @param data.onError {function} callback if the invoked service returns an error or is not available
    * @param data.onLoggedIn {function} callback if login was successful
    * @param data.onLoginFailed {function} callback if login was not successful
    * since the function executes an asynchron call there is not delivered any return value - if an internal server error occurs please contact mondiamedia, in person Nils Sowen
    */
    var login = function (data) {
        if (!base.checkProperties(data, 'object')) {
            base.log('missing data object as parameter in login function');
        } else {
            $.extend(data.options, {
                'forceLogin': true,
                'prefix': 'json'
            });
            wrapLoginFunc({
                onSuccess: function (result) {
                    if (base.checkProperties(data.onLoggedIn, 'function')) {
                        //result depends on Go-URL
                        data.onLoggedIn({
                            code: 200,
                            result: result
                        });
                    } else {
                        base.log('no callback for "logged in" functionality has been defined');
                    }
                },
                onError: function (result) {
                    if (base.checkProperties(data.onError, 'function')) {
                        data.onError(result);
                    } else {
                        base.log('no callback for "error" functionality has been defined');
                    }
                },
                onLoginFailed: function (result) {
                    if (base.checkProperties(data.onLoginFailed, 'function')) {
                        data.onLoginFailed(result);
                    } else {
                        base.log('no callback for "not logged in" functionality has been defined');
                    }
                },
                data: data.options
            });
        }
    };

    /**
    * @description public function to login in with msisdn and internetkennwort
    * @param data {object}
    * @param data.options {object}
    * @param data.options.msisdn {string} msisdn of customer - usually provided by a form
    * @param data.options.pass {string} - internetkennwort of customer - usually provided by a form / leave it blank if you want to force sms-pin login
    * @param data.options.cpass {string} - kundenkennwort of customer - usually provided by a form
    * @param data.onLoginFailed {function}
    * @param data.onLoggedIn {function}
    * @param data.onError {function}
    */
    auth.login = function (data) {
        login(data);
    };

    /**
    * @description function generates an ajax call and tries to logout the customer
    * @description url: https://eweb8.vfd2-testnet.de/dr/tmpl/logout (https only)
    * @param data {object}
    * @param data.onLogout {function} callback if logout was successful even when the customer is not logged in
    * @param data.onError {function} callback if the invoked service returns an error or is not available
    * since the function executes an asynchron call there is not delivered any return value - if an internal server error occurs please contact mondiamedia, in person Nils Sowen
    */
    auth.logout = function (data) {
        if (!base.checkProperties(data, 'object')) {
            base.log('missing data object as parameter in logout function');
        } else {
            $.ajax({
                url: config.urlLogout,
                dataType: 'json',
                headers: {
                    'x-vfssdublinversion': '2'
                },
                error: function (xhr, xmlHttpRequest, textStatus) {
                    if (base.checkProperties(data.onError, 'function')) {
                        data.onError();
                    } else {
                        base.log('no callback for "error" functionality has been defined');
                    }
                },
                success: function (result) {
                    if (base.checkProperties(data.onLogout, 'function')) {
                        data.onLogout();
                    } else {
                        base.log('no callback for "onLogout" functionality has been defined');
                    }
                }
            });
        }
    };

    auth.checkResultForLoginStatus = function (data) {
        if (data && data.code && 409 === parseInt(data.code, 10)) {
            return false;
        }
        return true;
    };
}(window.vf.bookservices.auth = window.vf.bookservices.auth || {}, jQuery));


/**
* @description require auth object and base object
*/
(function (orderSocs, $, undefined) {
    var base = vf.bookservices;
    /**
    * @description private function to generate the ajax call to the webservice
    * @param options
    */
    var sendCall = function (options) {
        $.ajax({
            url: options.url,
            type: 'POST',
            data: options.tarifoptionen,
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                if (!base.auth.checkResultForLoginStatus(result)) {
                    options.onLoginFailed(result);
                } else {
                    options.onSuccess(result);
                }
            },
            error: function () {
                options.onError(base.errorCodes.technicalError);
            }
        });
    };

    /**
    * @description
    * @param data {object}
    * @param data.tarifoptionen {string} name of wanted soc
    * @param data.isBookable {function} callback
    */
    orderSocs.bookSoc = function (data) {
        if (!base.checkProperties(data, 'object')) {
            base.log('missing data object as parameter in bookSoc function');
        } else {
            var options = {
                url: '/dr/cc/vf/api/services/tariff/add',
                onSuccess: function (result) {
                    if ('OK' === result.status) {
                        data.isBookable(base.errorCodes.socBooked);
                    } else {
                        data.isNotBookable(base.errorCodes.technicalError);
                    }
                },
                onLoginFailed: function () {
                    data.isNotBookable(base.errorCodes.notLoggedIn);
                },
                onError: function () {
                    data.onError(base.errorCodes.technicalError);
                },
                tarifoptionen: data.tarifoption
            };
            sendCall(options);
        }
    };

    /**
    * @description function checks if current soc is bookable for customer
    * @param data {object}
    * @param data.tarifoptionen {string} list with tarifoptionen which should be checked in this call. A Whitelist with allowed tarifoption is maintained seperately. You find this list under the following URL: http://eweb8.vfd2-testnet.de/scripts/tarifoption.mapping.js
    * @param data.isBookable {function}
    * @param data.isNotBookable {function}
    * @param data.onError {function}
    */
    orderSocs.isSocBookable = function (data) {
        if (!base.checkProperties(data, 'object')) {
            base.log('missing data object as parameter in isSocBookable function');
        } else {
            var options = {
                url: '/dr/cc/vf/api/services/tariff/offer',
                onSuccess: function (result) {
                    if ('OK' === result.status) {
                        if (0 < (result.bookableSocs.length)) {
                            //returns the firs matching bookable soc
                            data.isBookable(result.bookableSocs[0]);
                        } else if ('function' === typeof data.isRemoveable && 0 < result.removeableSocs.length) {
                            data.isRemoveable(result.removeableSocs[0]);
                        } else {
                            data.isNotBookable(base.errorCodes.socAlreadyBooked);
                        }
                    } else {
                        if ('SOC_EXISTS' === result.status) {
                            data.isNotBookable(base.errorCodes.socAlreadyBooked);
                        } else if ('SOC_NOT_BOOKABLE_FOR_SUBSCRIBER' === result.status) {
                            data.isNotBookable(base.errorCodes.notAllowed);
                        } else if ('ERROR_NO_BOOKABLE_SOC' === result.status) {
                            data.isNotBookable(base.errorCodes.notBookable);
                        } else {
                            data.isNotBookable(base.errorCodes.technicalError);
                        }
                    }
                },
                onLoginFailed: function (result) {
                    data.isNotBookable(base.errorCodes.notLoggedIn);
                },
                onError: function () {
                    data.onError();
                },
                tarifoptionen: data.tarifoptionen
            };
            sendCall(options);
        }
    };
}(window.vf.bookservices.orderSocs = window.vf.bookservices.orderSocs || {}, jQuery));

